import React, {Component} from 'react';
import PropTypes from "prop-types";


class IncludeCellRenderer extends Component {

  render() {
    let cmbObject = this.props.list.filter(
      x => x.guid == this.props.value
    );
    return cmbObject ? cmbObject[0].name : this.props.value;
  }
}

IncludeCellRenderer.propTypes = {
  value: PropTypes.any,
  list:PropTypes.any
};

export default IncludeCellRenderer;